<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <kykm-create-or-update v-model="kykm" :errors="errors"></kykm-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
    
        <v-table    ref="table"
                    :buttons="buttons"
                    :fields="fields"
                    pagination="server"
                    search
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import KYKMCreateOrUpdate from './components/KYKMCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        'kykm-create-or-update':KYKMCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:'KYKM',key:'Name',thClass:'w-16'},
                {name:'Kat Sayı',key:'Multiplier',thClass:'w-12'},
                {name:'Ücret Nevi Kodu',key:'KYKMKindCode',thClass:'w-12'},
                {name:'Ücret Nevi',key:'KYKMKindName',thClass:'w-12'},
                {name:'SGK Gün Kodu',key:'KYKMSgkDayKindCode',thClass:'w-12'},
                {name:'SGK Gün',key:'KYKMSgkDayKindName',thClass:'w-12'},
                {name:'Tip',key:'TIP',thClass:'w-12'},
                {name:'Sıra No',key:'SIRA_NO',thClass:'w-12'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            kykm:{
                Id:null,
                Name: null,
                Multiplier: 1,
                KYKMKindId: null,
                TIP: 1,
                SIRA_NO: null,
                KYKMSgkDayKindId: null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.kykm.Id = null
            this.kykm.Name= null
            this.kykm.Multiplier= 1
            this.kykm.KYKMKindId= null
            this.kykm.TIP = 1
            this.kykm.SIRA_NO= null
            this.kykm.KYKMSgkDayKindId= null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.KYKM.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.kykm.Id = item.Id
            this.kykm.Name= item.Name
            this.kykm.Multiplier= item.Multiplier
            this.kykm.KYKMKindId= item.KYKMKindId
            this.kykm.TIP = item.TIP
            this.kykm.SIRA_NO= item.SIRA_NO
            this.kykm.KYKMSgkDayKindId= item.KYKMSgkDayKindId
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.KYKM.CreateOrUpdate(this.editing,{
                    ...this.kykm,
                    KYKMSgkDayKindId: this.kykm.TIP == 1 ? this.kykm.KYKMSgkDayKindId : null,
                    Multiplier: this.kykm.TIP == 1 ? this.kykm.Multiplier : 0,
                }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli KYKM'yi silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.KYKM.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>